/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react';
import { Toolbar } from 'react-md';
import { admindb } from 'db'
import _ from 'lodash'

import './Footer.css'

class Footer extends Component {
	state = {
		news: []
	};

	handleUpdateNews = news => {
		this.setState({ news: news.val() });
	};

	componentDidMount() {
		admindb.onUpdateNews(this.handleUpdateNews);
	}

	render() {
		const { news } = this.state;

		return (
			<div className="footer">
				<Toolbar
					className="footer-toolbar-sub"
					title={<marquee scrolldelay="120">{ !_.isEmpty(news) ? news.join(" +++ ") : "" }</marquee>}
				/>
			</div>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx